export default [
    {
        path: '/staff/payroll',
        name: 'Payroll',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Payroll',
        },
        components: {
            default: () => import('@views/staff/PayrollIndex.vue'),
        },
    },
    {
        path: '/staff/team-directory',
        name: 'TeamDirectory',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Team directory',
        },
        components: {
            default: () => import('@views/staff/StaffIndex.vue'),
        },
    },
    {
        path: '/staff/team-directory/:companyId/create',
        name: 'TeamCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Create team member',
        },
        props: true,
        components: {
            default: () => import('@views/staff/StaffCreate.vue'),
        },
    },
    {
        path: '/companies/:companyId/staff/team-directory/:staffId/edit',
        name: 'CompanyTeamEdit',
        props: {
            default: (route) => ({
                companyId: route.params.companyId,
                staffId: route.params.staffId,
            }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Edit team member',
        },
        components: {
            default: () => import('@views/staff/StaffEdit.vue'),
        },
    },
    {
        path: '/staff/:staffId/edit',
        name: 'TeamEdit',
        props: {
            default: (route) => ({
                staffId: route.params.staffId,
            }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Edit team member',
        },
        components: {
            default: () => import('@views/staff/StaffMuvalEdit.vue'),
        },
    },
    // Timesheets
    {
        path: '/staff/timesheet-management',
        name: 'TimesheetManagement',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Timesheet management',
        },
        components: {
            default: () => import('@views/staff/timesheets/TimesheetManagementIndex.vue'),
        },
    },
    {
        path: '/staff/timesheets/:id?',
        name: 'TimesheetStaff',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'My timesheets',
        },
        components: {
            default: () => import('@views/staff/timesheets/TimesheetIndex.vue'),
        },
    },
    {
        path: '/staff/timesheets/:id/view',
        name: 'TimesheetView',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Timesheet view',
        },
        components: {
            default: () => import('@views/staff/timesheets/TimesheetView.vue'),
        },
    },
    {
        path: '/staff/timesheets/:id/edit',
        name: 'WeeklyTimesheet',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Weekly timesheet',
        },
        components: {
            default: () => import('@views/staff/timesheets/TimesheetEdit.vue'),
        },
    },
];
